import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../../context/ConstantAPISContext";
import IrvTarifeListeAPI from "../../../../apis/OB/Get/IrvTarifeListeAPI";
import { showToast } from "../../../../helpers/ToastifyHelper";
import IlanReklamTarifeGetAPI from "../../../../apis/OB/Get/IlanReklamTarifeGetAPI";
import ListHeaderComponent from "../../../../components/OB/ListHeaderComponent";
import { Form, Formik } from "formik";
import { FormControl, InputLabel, MenuItem, Select, CircularProgress } from "@mui/material";
import SearchComponent from "../../../../components/OB/SearchComponent";
import TableComponent1 from "../../../../components/OB/TableComponent1";
import IlanReklamVergisiTarifeleriPopup from "../../../../components/OB/popups/IlanReklamTarifeleriPopUp";
import TableComponent from "../../../../components/OB/TableComponent";
import EvKatSayiDegerlemeOraniAPI from "../../../../apis/OB/Get/EvKatSayiDegerlemeOraniAPI";
const KatsayilarVeDegerlemeOrani: React.FC = () => {

    const columns = [
        { header: "Değerleme Oranı", field: "degerlemeOrani", className: "text-center" },
        { header: "Mesken Oranı", field: "meskenOrani", className: "text-center" },
        { header: "İşyeri Oranı", field: "isYeriOrani", className: "text-center" },
        { header: "Arsa Oranı", field: "arsaOrani", className: "text-center" },
        { header: "Arazi Oranı", field: "araziOrani", className: "text-center" },
        { header: "Asansör Yüzdesi", field: "asansorYuzdesi", className: "text-center" },
        { header: "Kalorifer Yüzdesi", field: "kaloriferYuzdesi", className: "text-center" },
    ];
    const [data, setData] = useState<any[]>([]);
    const [tarifeGetData, setTarifeGetData] = useState<any[]>([]);
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { yilListe } = useContext(ConstantAPISContext);
    const [selectedYear, setSelectedYear] = useState(Number(new Date().getFullYear()));

    const [isLoading, setisLoading] = useState<boolean>(false);

    //Pop-Up
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const openPopup = () => {
        isPopupVisible == true ?
            setIsPopupVisible(false) :
            setIsPopupVisible(true);
    };
    //EvKatSayiDegerlemeOraniAPI
    useEffect(() => {
        fetchData(false);
    }, [])

    const fetchData = async (isPass: boolean = true) => {
        if (selectedYear !== 0) {
            setisLoading(true);
            const response = await EvKatSayiDegerlemeOraniAPI.getEvKatsayiDegerlemeOraniListe(
                selectedYear
            );
            setData(response.data);
            setTimeout(() => {
                setisLoading(false);

            }, 100)
            setSearchControl(true)


        }
        else {
            setSearchControl(false)
            showToast("Lütfen Yılı Seçiniz", "error");
        }
    }

    const handleTemizle = () => {
        setSelectedYear(Number(new Date().getFullYear()));

    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
            <div className="card-body p-0">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Yıl</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        name="yil"
                                        label="yil"
                                        error={selectedYear == undefined && searchControl == false ? true : false}

                                        value={selectedYear || ""}
                                        onChange={(e) => {
                                            setSelectedYear(Number(e.target.value || undefined));
                                        }}                                >
                                        {yilListe.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.yili}                                            >
                                                {item.yili}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="d-flex  flex-row ms-auto ">
                                <SearchComponent
                                    fetchData={fetchData}
                                    onTemizle={handleTemizle}
                                    setData={setData} />
                            </div>
                        </div>
                    </Form>
                </Formik>
                {isLoading ?
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                        <CircularProgress />
                    </div>
                    :
                    <TableComponent columns={columns} data={data} recordsPerPage={10}></TableComponent>
                }
                {isPopupVisible && (
                    <div style={{ height: "100vh", position: "absolute", width: "100%", padding: "20px", backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: "1000" }}>
                        <IlanReklamVergisiTarifeleriPopup
                            openPopup={openPopup}
                            data={tarifeGetData}
                        />
                    </div>
                )}
            </div >
        </div >
    )
}

export default KatsayilarVeDegerlemeOrani;